import { useTranslation } from "react-i18next";
import PropTypes from 'prop-types';
const About = ({homepagedata}) => {
    const {t} = useTranslation()
    let count = 50
    
      return (    
        <section className="AbtSec">
            <div className="container">
                <div className="AbtDv">
                    <div className="row align-items-center">
                        <div className="col-lg-12" data-aos="fade-up" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-delay="100">
                            <h5>{t('About')}</h5>
                            <h3 dangerouslySetInnerHTML={{__html:homepagedata?.about_title}}></h3>
                         
                          <p dangerouslySetInnerHTML={{__html:homepagedata?.about_description}}></p>
                        </div>
                        <div className="col-lg-12">
                            <h6>{t('POWERED BY')}</h6>
                                                    
                        
                                    <div className="AbtPwdByDv">
                             {homepagedata?.poweredby?.map((rowdata, index) => {
                                count += 50; 
                                return (
                                    <div className='AbtPwdByDvIg' data-aos="fade-up" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-delay={count} key={rowdata}>
                                        <img src={rowdata?.poweredbyimages} alt={`Powered by ${index + 1}`} />
                                    </div>
                                );
                            })}
                           
                        
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
   
}

About.propTypes ={
    homepagedata: PropTypes.shape({
    about_title: PropTypes.any,
    about_description : PropTypes.any,
    poweredby: PropTypes.arrayOf(
        PropTypes.shape({
            poweredbyimages: PropTypes.any,
        })
    )
    }), 
}

export default About;
